import { AuctionProduct } from '@/modules/calendar/model/auctions/auction-product';
import { DataRelease } from '@/modules/calendar/model/calendar/data-release';

export class TopicFilter {
  [key: string]: any;

  allSelected = true;

  constructor(topicFilter?: TopicFilter) {
    if (topicFilter) {
      for (const k in topicFilter) {
        this[k] = topicFilter[k];
      }
    }
  }

  allowRelease(dataRelease?: DataRelease): boolean {
    if (!dataRelease) return true;

    if (this.allSelected) return true;

    let allow = false;

    dataRelease.series.forEach(value => {
      value.topics.forEach(topic => {
        if (this[topic.qcode]) allow = true;
      });
    });

    return allow;
  }

  allowAuction(auctionProducts: AuctionProduct[]): boolean {
    if (!auctionProducts || auctionProducts.length === 0) return true;

    if (this.allSelected) return true;

    let allow = false;

    auctionProducts.forEach(auctionProduct => {
      auctionProduct.type.topics.forEach(topic => {
        if (this[topic.qcode]) allow = true;
      });
    });

    return allow;
  }
}
